Vendd.Scripts.load(function () {

    var $wrapper = $('.side-menu');

    if ($wrapper.length < 1)
        return;

    var wrapper = $wrapper.get(0);

    var iconOpen = $wrapper.data('icon-open');
    var iconClose = $wrapper.data('icon-close');

    wrapper.open = function () {
        if ($wrapper.hasClass('with-popup')) {
            $('.header-overlay').addClass('visible');
            $('html, body').addClass('no-scroll');
        }
        $('.mobile-title', $wrapper).addClass('active');
        $('.mobile-title > .icon', $wrapper).removeClass(iconOpen).addClass(iconClose);
        $('.nav-1', $wrapper).addClass('active');
    };

    wrapper.close = function () {
        $('.mobile-title', $wrapper).removeClass('active');
        $('.mobile-title > .icon', $wrapper).removeClass(iconClose).addClass(iconOpen);
        $('.nav-1', $wrapper).removeClass('active');
        if ($wrapper.hasClass('with-popup')) {
            $('html, body').removeClass('no-scroll');
            $('.header-overlay').removeClass('visible');
        }
    };
    
    if ($wrapper.hasClass('x-account-menu')) {
        $wrapper.on('click', '.js-logout', function (e) {
            e.preventDefault();
            Vendd.MessageBus.publishAsync($wrapper, new Vendd.User.Messages.Logout());
        });
    }

    $wrapper.on('click', '.mobile-title', function (e) {
        e.preventDefault();

        var $this = $(this);

        if ($this.hasClass('active')) {
            wrapper.close();
        } else {
            wrapper.open();
        }
    });

    if ($wrapper.hasClass('with-toggle')) {
        $(document).on('click', function (e) {
            if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
                wrapper.close();
            }
        });
    }

    if ($wrapper.hasClass('with-popup')) {
        $wrapper.on('click', '.js-close-categories', function (e) {
            e.preventDefault();

            var $this = $(this).closest('.nav-1');

            if ($this.hasClass('active')) {
                wrapper.close();
            }
        });

        $('.header-overlay').on('click', function (e) {
            e.preventDefault();
            wrapper.close();
        });

        $(window).resize($.debounce(50, function () {
            if ($(window).outerWidth() >= 960) {
                wrapper.close();
            }
        }));
    }

});

